<nz-switch [(ngModel)]="switchValue" [disabled]="isSkuIdentifierColumn()" (ngModelChange)="onSwitchChange($event)"> </nz-switch>
